import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import _ from 'underscore';

import helpers from './../../lib/helpers';

function NotFound(props) {
	const history = useHistory();

	const pageRoot = helpers.getPageRoot(history.location.pathname);

	return (
		<div className="search-no-results mt-4">
			<div className="icon notfound" />
			<p className="lead">{window.l('Þessi færsla fannst ekki undir síðuhlutanum')}  <i>{helpers.getPathWithTitles(history.location.pathname).toLowerCase()}</i></p>
		</div>
	)
}

export default NotFound;
